import React from "react";
import { Link } from "react-router-dom";

export default function MiertHoppHomes() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-[#0a0a0a] to-[#111] relative overflow-hidden">
      
      {/* POWERFUL Animated Background - Connection Network */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {/* CSS Animations */}
        <style>{`
          @keyframes network-pulse {
            0%, 100% { opacity: 0.4; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.2); }
          }
          @keyframes connection-flow {
            0% { stroke-dashoffset: 100; opacity: 0.3; }
            50% { opacity: 0.8; }
            100% { stroke-dashoffset: 0; opacity: 0.3; }
          }
          @keyframes node-glow {
            0%, 100% { box-shadow: 0 0 20px rgba(220,38,38,0.5), 0 0 40px rgba(220,38,38,0.3); }
            50% { box-shadow: 0 0 40px rgba(220,38,38,0.8), 0 0 80px rgba(220,38,38,0.5), 0 0 120px rgba(220,38,38,0.3); }
          }
          @keyframes sweep {
            0% { transform: translateX(-100%) rotate(-45deg); }
            100% { transform: translateX(200%) rotate(-45deg); }
          }
          @keyframes float-strong {
            0%, 100% { transform: translateY(0px) scale(1); }
            50% { transform: translateY(-30px) scale(1.1); }
          }
          @keyframes rotate-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse-ring {
            0% { transform: scale(0.8); opacity: 0.8; }
            50% { transform: scale(1.5); opacity: 0; }
            100% { transform: scale(0.8); opacity: 0; }
          }
          @keyframes beam {
            0%, 100% { opacity: 0.2; height: 0%; }
            50% { opacity: 0.6; height: 100%; }
          }
        `}</style>
        
        {/* Main gradient sweep */}
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className="absolute inset-0 w-[200%] h-[200%] -top-1/2 -left-1/2"
            style={{
              background: 'linear-gradient(90deg, transparent 0%, rgba(220,38,38,0.15) 25%, rgba(220,38,38,0.3) 50%, rgba(220,38,38,0.15) 75%, transparent 100%)',
              animation: 'sweep 8s ease-in-out infinite'
            }}
          />
        </div>
        
        {/* Network SVG - Connecting lines */}
        <svg className="absolute inset-0 w-full h-full" style={{ opacity: 0.6 }}>
          <defs>
            <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(220,38,38,0)" />
              <stop offset="50%" stopColor="rgba(220,38,38,0.8)" />
              <stop offset="100%" stopColor="rgba(220,38,38,0)" />
            </linearGradient>
          </defs>
          {/* Connection lines */}
          <line x1="10%" y1="20%" x2="30%" y2="35%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 3s linear infinite' }} />
          <line x1="30%" y1="35%" x2="50%" y2="15%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 4s linear infinite 0.5s' }} />
          <line x1="50%" y1="15%" x2="75%" y2="30%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 3.5s linear infinite 1s' }} />
          <line x1="75%" y1="30%" x2="90%" y2="20%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 4.5s linear infinite 0.3s' }} />
          <line x1="20%" y1="60%" x2="45%" y2="50%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 3.2s linear infinite 0.7s' }} />
          <line x1="45%" y1="50%" x2="70%" y2="65%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 3.8s linear infinite 1.2s' }} />
          <line x1="70%" y1="65%" x2="85%" y2="55%" stroke="url(#lineGrad)" strokeWidth="2" strokeDasharray="10,5" style={{ animation: 'connection-flow 4.2s linear infinite 0.2s' }} />
          <line x1="30%" y1="35%" x2="45%" y2="50%" stroke="url(#lineGrad)" strokeWidth="1.5" strokeDasharray="8,4" style={{ animation: 'connection-flow 5s linear infinite 0.8s' }} />
          <line x1="50%" y1="15%" x2="45%" y2="50%" stroke="url(#lineGrad)" strokeWidth="1.5" strokeDasharray="8,4" style={{ animation: 'connection-flow 4.8s linear infinite 1.5s' }} />
          <line x1="75%" y1="30%" x2="70%" y2="65%" stroke="url(#lineGrad)" strokeWidth="1.5" strokeDasharray="8,4" style={{ animation: 'connection-flow 5.2s linear infinite 0.4s' }} />
        </svg>
        
        {/* Network Nodes - Glowing dots */}
        <div className="absolute top-[20%] left-[10%] w-4 h-4 rounded-full bg-secondary" style={{ animation: 'node-glow 2s ease-in-out infinite, float-strong 6s ease-in-out infinite' }} />
        <div className="absolute top-[35%] left-[30%] w-5 h-5 rounded-full bg-secondary" style={{ animation: 'node-glow 2.5s ease-in-out infinite 0.3s, float-strong 7s ease-in-out infinite 1s' }} />
        <div className="absolute top-[15%] left-[50%] w-6 h-6 rounded-full bg-secondary" style={{ animation: 'node-glow 2s ease-in-out infinite 0.6s, float-strong 5s ease-in-out infinite 0.5s' }} />
        <div className="absolute top-[30%] right-[25%] w-4 h-4 rounded-full bg-secondary" style={{ animation: 'node-glow 2.3s ease-in-out infinite 0.9s, float-strong 8s ease-in-out infinite 2s' }} />
        <div className="absolute top-[20%] right-[10%] w-5 h-5 rounded-full bg-secondary" style={{ animation: 'node-glow 2.1s ease-in-out infinite 1.2s, float-strong 6.5s ease-in-out infinite 1.5s' }} />
        <div className="absolute top-[60%] left-[20%] w-5 h-5 rounded-full bg-secondary" style={{ animation: 'node-glow 2.4s ease-in-out infinite 0.2s, float-strong 7.5s ease-in-out infinite 0.8s' }} />
        <div className="absolute top-[50%] left-[45%] w-6 h-6 rounded-full bg-secondary" style={{ animation: 'node-glow 2.2s ease-in-out infinite 0.5s, float-strong 5.5s ease-in-out infinite 1.2s' }} />
        <div className="absolute top-[65%] right-[30%] w-4 h-4 rounded-full bg-secondary" style={{ animation: 'node-glow 2.6s ease-in-out infinite 0.8s, float-strong 8.5s ease-in-out infinite 0.3s' }} />
        <div className="absolute top-[55%] right-[15%] w-5 h-5 rounded-full bg-secondary" style={{ animation: 'node-glow 2s ease-in-out infinite 1.1s, float-strong 6s ease-in-out infinite 1.8s' }} />
        
        {/* Pulse rings around main nodes */}
        <div className="absolute top-[15%] left-[50%] w-16 h-16 -ml-8 -mt-8 rounded-full border-2 border-secondary/50" style={{ animation: 'pulse-ring 3s ease-out infinite' }} />
        <div className="absolute top-[50%] left-[45%] w-20 h-20 -ml-10 -mt-10 rounded-full border-2 border-secondary/50" style={{ animation: 'pulse-ring 3.5s ease-out infinite 0.5s' }} />
        <div className="absolute top-[35%] left-[30%] w-14 h-14 -ml-7 -mt-7 rounded-full border-2 border-secondary/50" style={{ animation: 'pulse-ring 2.8s ease-out infinite 1s' }} />
        
        {/* Rotating outer ring */}
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-secondary/20"
          style={{ animation: 'rotate-slow 60s linear infinite' }}
        >
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-secondary/60" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-3 h-3 rounded-full bg-secondary/60" />
          <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-secondary/60" />
          <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-secondary/60" />
        </div>
        
        {/* Large ambient glows */}
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-secondary/20 via-secondary/5 to-transparent rounded-full blur-[100px]" style={{ animation: 'float-strong 10s ease-in-out infinite' }} />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tl from-blue-500/15 via-blue-500/5 to-transparent rounded-full blur-[80px]" style={{ animation: 'float-strong 12s ease-in-out infinite 3s' }} />
        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] bg-gradient-to-bl from-secondary/10 via-transparent to-transparent rounded-full blur-[60px]" style={{ animation: 'float-strong 8s ease-in-out infinite 1.5s' }} />
        
        {/* Vertical light beams */}
        <div className="absolute left-[15%] top-0 w-px h-full bg-gradient-to-b from-transparent via-secondary/30 to-transparent" style={{ animation: 'beam 4s ease-in-out infinite' }} />
        <div className="absolute left-[85%] top-0 w-px h-full bg-gradient-to-b from-transparent via-secondary/30 to-transparent" style={{ animation: 'beam 5s ease-in-out infinite 2s' }} />
      </div>
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 overflow-hidden z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 via-transparent to-transparent" />
        <div className="max-w-5xl mx-auto px-4 relative z-10">
          <div className="text-center mb-8">
            <span className="inline-block bg-secondary/10 text-secondary text-xs font-bold px-4 py-2 rounded-full mb-4 border border-secondary/20">
              RÓLUNK
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-6">
              Mi a <span className="text-secondary">HOPPhomes</span>?
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              A HOPPhomes nem egy ház. <span className="text-white font-medium">Rendszer a döntéshez.</span>
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 1: HOPPhomes Platform */}
      <section className="py-12 md:py-20 relative z-10">
        <div className="max-w-5xl mx-auto px-4">
          
          {/* Platform Definition */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#111] rounded-3xl p-8 md:p-12 border border-white/10 mb-12">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-secondary/20 flex items-center justify-center text-2xl flex-shrink-0">
                🏛️
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
                  Strukturált lakhatási platform
                </h2>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed">
                  A HOPPhomes egy strukturált lakhatási platform, amely <span className="text-white font-medium">átlátható, gyors és biztonságos</span> megoldásokat kínál azoknak, akik moduláris vagy mobil otthonban gondolkodnak.
                </p>
              </div>
            </div>
            
            <div className="border-l-2 border-secondary/50 pl-6 py-4 my-8 bg-secondary/5 rounded-r-xl">
              <p className="text-lg md:text-xl text-white italic">
                „Célunk, hogy a lakhatással kapcsolatos döntések ne kockázatra, hanem <span className="text-secondary font-semibold">valós információkra és működő rendszerekre</span> épüljenek."
              </p>
            </div>
            
            <p className="text-gray-400 text-base leading-relaxed">
              A HOPPhomes ezért nem egy terméket tol előtérbe, hanem <span className="text-white">rendszerbe szervezi a lehetőségeket</span>.
              Nem ígéretekkel dolgozunk, hanem átláthatósággal, összehasonlíthatósággal és ellenőrizhető háttérrel.
            </p>
          </div>

          {/* Why HOPPhomes was created */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-[#1a1a1a] rounded-2xl p-6 md:p-8 border border-white/5">
              <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-3">
                <span className="text-2xl">❓</span>
                Miért jött létre?
              </h3>
              <p className="text-gray-400 mb-4">
                A moduláris és mobilház piac gyorsan nő, de az ügyfelek gyakran bizonytalanok:
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-gray-300">
                  <span className="text-secondary mt-1">•</span>
                  <span>Ki a valódi gyártó?</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300">
                  <span className="text-secondary mt-1">•</span>
                  <span>Mi van a számok mögött?</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300">
                  <span className="text-secondary mt-1">•</span>
                  <span>Mi a reális ár?</span>
                </li>
                <li className="flex items-start gap-2 text-gray-300">
                  <span className="text-secondary mt-1">•</span>
                  <span>Mire számíthatnak hosszú távon?</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-[#1a1a1a] rounded-2xl p-6 md:p-8 border border-secondary/20">
              <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-3">
                <span className="text-2xl">💡</span>
                A HOPPhomes válasza
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Összekötjük a <span className="text-white font-medium">gyártói kapacitást</span>, a <span className="text-white font-medium">technológiát</span> és az <span className="text-white font-medium">ügyféligényeket</span> egy átlátható rendszerben.
              </p>
              <div className="mt-6 pt-6 border-t border-white/10">
                <p className="text-secondary font-semibold text-lg">
                  A cél nem a gyors döntés,<br/>
                  hanem a <span className="text-white">jó döntés</span>.
                </p>
              </div>
            </div>
          </div>

          {/* Role of HOPPhomes */}
          <div className="bg-gradient-to-r from-secondary/10 via-secondary/5 to-transparent rounded-2xl p-6 md:p-8 border border-secondary/20 mb-12">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-6">
              A HOPPhomes szerepe
            </h3>
            <div className="grid sm:grid-cols-3 gap-4 mb-6">
              <div className="bg-black/30 rounded-xl p-4 text-center">
                <span className="text-red-400 text-2xl">✕</span>
                <p className="text-gray-400 mt-2">nem gyártó</p>
              </div>
              <div className="bg-black/30 rounded-xl p-4 text-center">
                <span className="text-red-400 text-2xl">✕</span>
                <p className="text-gray-400 mt-2">nem kivitelező</p>
              </div>
              <div className="bg-black/30 rounded-xl p-4 text-center">
                <span className="text-green-400 text-2xl">✓</span>
                <p className="text-white mt-2 font-medium">belépési pont és döntéstámogató rendszer</p>
              </div>
            </div>
            <p className="text-gray-300">
              Itt jelennek meg: <span className="text-white">moduláris házak</span>, <span className="text-white">mobilház megoldások</span>, <span className="text-white">gyártói és kivitelezői partnerek</span> – egységes struktúrában, összehasonlítható módon.
            </p>
          </div>

          {/* Not for everyone */}
          <div className="bg-[#0d0d0d] rounded-2xl p-6 md:p-8 border border-white/5">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-3">
              <span className="text-2xl">🎯</span>
              Nem mindenkinek készült
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              A HOPPhomes azoknak szól, akik <span className="text-white font-medium">nem akarnak zsákbamacskát venni</span>, és nem szeretnének hónapokat veszíteni rossz választásokkal.
            </p>
            <p className="text-gray-400">
              Akik értik, hogy a lakhatás nem impulzusvásárlás, hanem <span className="text-secondary font-medium">rendszerszintű döntés</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-5xl mx-auto px-4 relative z-10">
        <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent my-8" />
      </div>

      {/* SECTION 2: Manufacturing Partner */}
      <section className="py-12 md:py-20 relative z-10">
        <div className="max-w-5xl mx-auto px-4">
          
          {/* Partner Section Header */}
          <div className="text-center mb-12">
            <span className="inline-block bg-blue-500/10 text-blue-400 text-xs font-bold px-4 py-2 rounded-full mb-4 border border-blue-500/20">
              GYÁRTÓI PARTNER
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
              Moduláris otthonok gyártói háttere
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              A HOPPhomes rendszerében megjelenő moduláris otthonok mögött több mint 20 éves építőipari tapasztalattal rendelkező gyártói háttér áll.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
            <div className="bg-[#1a1a1a] rounded-xl p-5 text-center border border-white/5">
              <div className="text-3xl md:text-4xl font-black text-secondary mb-1">35.000</div>
              <div className="text-xs md:text-sm text-gray-400">m² üzemi terület</div>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-5 text-center border border-white/5">
              <div className="text-3xl md:text-4xl font-black text-white mb-1">13</div>
              <div className="text-xs md:text-sm text-gray-400">ház párhuzamosan</div>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-5 text-center border border-white/5">
              <div className="text-3xl md:text-4xl font-black text-white mb-1">20+</div>
              <div className="text-xs md:text-sm text-gray-400">év tapasztalat</div>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-5 text-center border border-white/5">
              <div className="text-3xl md:text-4xl font-black text-white mb-1">22</div>
              <div className="text-xs md:text-sm text-gray-400">telephely országszerte</div>
            </div>
          </div>

          {/* New direction */}
          <div className="bg-gradient-to-br from-blue-500/10 via-[#1a1a1a] to-[#1a1a1a] rounded-2xl p-6 md:p-8 border border-blue-500/20 mb-8">
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
              <span className="text-2xl">🚀</span>
              Új irány, biztos alapokon
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              2024 elején a tulajdonosi kör stratégiai döntést hozott, és a vállalat saját moduláris otthonok gyártásába kezdett. A gyártás egy <span className="text-white font-medium">35.000 négyzetméteres üzemi területen</span> zajlik, ahol egyszerre akár <span className="text-white font-medium">13 ház</span> is készülhet párhuzamosan, ellenőrzött körülmények között, ipari szintű minőségbiztosítással.
            </p>
            <p className="text-gray-400 text-sm">
              Ez a kapacitás nem ígéret, hanem valós, működő gyártási háttér.
            </p>
          </div>

          {/* Why competitive */}
          <div className="bg-[#1a1a1a] rounded-2xl p-6 md:p-8 border border-white/5 mb-8">
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3">
              <span className="text-2xl">💪</span>
              Miért versenyképes a gyártás?
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-green-400 mt-1">✓</span>
                  <p className="text-gray-300">Az alapanyagok jelentős része <span className="text-white">közvetlen beszerzésből</span> származik</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-green-400 mt-1">✓</span>
                  <p className="text-gray-300">A felhasznált építőanyagok mintegy <span className="text-white font-bold">70%-át</span> a vállalat saját maga állítja elő</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-green-400 mt-1">✓</span>
                  <p className="text-gray-300">Csökkentett költségek és <span className="text-white">folyamatos minőségellenőrzés</span></p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-green-400 mt-1">✓</span>
                  <p className="text-gray-300">Rendelkezésre álló alapanyag-készlet = <span className="text-white">árstabilitás és ügyfélbiztonság</span></p>
                </div>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="bg-gradient-to-r from-secondary/10 via-transparent to-blue-500/10 rounded-2xl p-6 md:p-8 border border-white/10">
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
              <span className="text-2xl">🎯</span>
              Küldetés
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              A cél olyan <span className="text-white font-medium">minőségi, modern és fenntartható</span> moduláris otthonok gyártása, amelyek gyorsan elérhetőek, kiszámítható költséggel és átlátható műszaki tartalommal.
            </p>
            <p className="text-gray-400">
              A gyártói megközelítés nem kompromisszumokra épül, hanem <span className="text-secondary">ipari logikára, tervezhetőségre és hosszú távú működésre</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-12 md:py-16 relative z-10">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <p className="text-gray-400 mb-6">
            Készen állsz megismerni a lehetőségeket?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/mobilhazak"
              className="inline-flex items-center justify-center gap-2 bg-secondary hover:bg-secondary/90 text-white font-bold px-8 py-4 rounded-xl transition-all"
            >
              Mobilházak →
            </Link>
            <Link 
              to="/egyedi-hazak"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-8 py-4 rounded-xl transition-all border border-white/[0.08]"
            >
              Egyedi házak építése
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
